// NOTE TO DCH: At one point I thought this was needed for the react-day-picker
// library. Turns out it wasn't, but I left it here in case you wanted to use it.
// It's an easy way for moment to display Chinese-formatted dates throughout the
// app.
//import { isDeployRegionChina } from './constants'
//const isChina = isDeployRegionChina()
//(async () => {
//  if (isChina) {
//    // Importing this sets all moment instances to the Chinese locale. This
//    // means that everywhere moment is used in the app it will be configured
//    // to display datetimes in Chinese.
//    //await import('moment/locale/zh-cn')
//  }
//})();

const generateLocalesMap = localesArr => {
  const result = {}
  if (localesArr && Array.isArray(localesArr)) {
    localesArr.forEach(localeObj => {
      const { id, text } = localeObj
      result[id] = text
    })
  }
  return result
}

export const formatLangCode = code => {
  const [lang, region] = code.split(/[-_]/)
  return region ? `${lang.toLowerCase()}_${region.toUpperCase()}` : lang.toLowerCase()
}

export default generateLocalesMap
